import { all } from 'redux-saga/effects'
import user from './user/sagas'
import menu from './menu/sagas'
import settings from './settings/sagas'
import dashboard from './dashboard/sagas'
import allUsers from './allUsers/sagas'
import refunds from './refunds/sagas'
import utility from './utility/sagas'
import agentDashboard from './agentDashboard/sagas'
import transaction from './transaction/sagas'
import business from './business/sagas'
import customer from './customer/sagas'
import payments from './payments/sagas'
import invoices from './invoices/sagas'
import checkouts from './checkouts/sagas'
import peyme from './peyme/sagas'

export default function* rootSaga() {
  yield all([
    user(),
    agentDashboard(),
    transaction(),
    menu(),
    settings(),
    dashboard(),
    allUsers(),
    refunds(),
    utility(),
    business(),
    customer(),
    payments(),
    invoices(),
    checkouts(),
    peyme(),
  ])
}
